import { useTranslation } from '@translations';
import { getCalculatorDataAttrs } from './utils';

export const useDataAttributes = () => {
    const { inputs, startSavingNow, totalsPanel } = useTranslation();

    return {
        saveInFundButtonDataAttrs: getCalculatorDataAttrs('save-in-fund-button', startSavingNow.saveInFund),
        contactAdvisorButtonDataAttrs: getCalculatorDataAttrs('contact-advisor-button', startSavingNow.contactAdvisor),
        aboutCalculationsInfoButtonDataAttrs: getCalculatorDataAttrs(
            'about-calculations-info-button',
            totalsPanel.aboutCalculationsLinkText,
        ),
        compareWithSavingsAccountCheckboxDataAttrs: getCalculatorDataAttrs(
            'compare-with-savings-account-checkbox',
            inputs.compareWithSavingsAccountCheckbox,
        ),
        inputFieldDataAttrs: {
            initialInvestment: getCalculatorDataAttrs('input-field', inputs.initialInvestment),
            monthlyContribution: getCalculatorDataAttrs('input-field', inputs.monthlyContribution),
            savingPeriodYears: getCalculatorDataAttrs('input-field', inputs.savingPeriodYears),
        },
        sliderInputDataAttrs: {
            initialInvestment: getCalculatorDataAttrs('slider-input', inputs.initialInvestment),
            monthlyContribution: getCalculatorDataAttrs('slider-input', inputs.monthlyContribution),
            savingPeriodYears: getCalculatorDataAttrs('slider-input', inputs.savingPeriodYears),
        },
    };
};
